import React from "react";
import { Link, useLocation } from "react-router-dom";

// Two small fixed-position circular logos that sit at the bottom corners of
// every themed page, gently echoing the header. B+ medallion bottom-left,
// Kathakala emblem bottom-right. Suppressed on the same routes as the
// SiteHeader so we don't double-up on Sessions / Utsavam.

function shouldSuppress(pathname) {
  if (!pathname) return false;
  return (
    pathname === "/sessions" ||
    pathname.startsWith("/sessions/") ||
    pathname.startsWith("/utsavam")
  );
}

const PageCornerBadges = () => {
  const { pathname } = useLocation();
  if (shouldSuppress(pathname)) return null;
  return (
    <>
      <Link
        to="/"
        title="B+ With Bhaskar"
        className="fixed bottom-3 left-3 md:bottom-4 md:left-4 z-40 group"
      >
        <div className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden bg-kk-ink shadow-[0_4px_18px_rgba(0,0,0,0.6)] group-hover:shadow-[0_0_24px_rgba(212,168,67,0.5)] transition-all">
          <img
            src="/logos/bplus_circular.png"
            alt="B+ With Bhaskar"
            className="w-full h-full object-cover"
          />
        </div>
      </Link>
      <Link
        to="/"
        title="కథాకళ · Kathakala"
        className="fixed bottom-3 right-3 md:bottom-4 md:right-4 z-40 group"
      >
        <div className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden bg-kk-ink shadow-[0_4px_18px_rgba(0,0,0,0.6)] group-hover:shadow-[0_0_24px_rgba(212,168,67,0.5)] transition-all">
          <img
            src="/logos/kathakala_emblem_circular.png"
            alt="Kathakala"
            className="w-full h-full object-cover"
          />
        </div>
      </Link>
    </>
  );
};

export default PageCornerBadges;
